import { THEME_CONSTANTS } from '@cof/plastic-components';
import { useTheme } from 'styled-components';

const { COLORS } = THEME_CONSTANTS;

const useBackground = (page: any, defaultBg = COLORS.global.white) => {
    const theme = useTheme();
    // @ts-expect-error TS2339: Property 'pages' does not exist on type 'DefaultTheme'.
    return theme?.pages?.[page]?.background ?? defaultBg;
};

export default useBackground;
